<template>
  <modal :show.sync="show" :on-close="onClose">
    <div class="column content-box">
      <woot-modal-header :header-title="$t('IMPORT_SCHOOL_CONTACT.TITLE')">
        <p>
          {{ $t('IMPORT_SCHOOL_CONTACT.DESC') }}
        </p>
        <p>
          <a :href="'/downloads/import-school-contacts-sample.csv'" download="import-contacts-sample">{{
            $t('IMPORT_SCHOOL_CONTACT.CONTACTS_EXAMPLE_DOWNLOAD_LABEL')
          }}</a>
        </p>
        <p>
          <a :href="'/downloads/import-school-enrollments-sample.csv'" download="import-enrollments-sample">{{
            $t('IMPORT_SCHOOL_CONTACT.ENROLLMENTS_EXAMPLE_DOWNLOAD_LABEL')
          }}</a>
        </p>
      </woot-modal-header>
      <div class="row modal-content">
        <div class="medium-12 columns">
          <label>
            <span>{{ $t('IMPORT_CONTACTS.FORM.LABEL') }}</span>
            <input
              id="file"
              ref="file"
              type="file"
              accept="text/csv"
              @change="handleFileUpload"
            />
          </label>
        </div>
        <div class="modal-footer">
          <div class="medium-12 columns">
            <woot-button
              :disabled="uiFlags.isCreating || !file"
              :loading="uiFlags.isCreating"
              @click="uploadFileWithContacts"
            >
              {{ $t('IMPORT_SCHOOL_CONTACT.FORM.CONTACTS_SUBMIT') }}
            </woot-button>
            <woot-button
              :disabled="uiFlags.isCreating || !file"
              :loading="uiFlags.isCreating"
              @click="uploadFileWithEnrollments"
            >
              {{ $t('IMPORT_SCHOOL_CONTACT.FORM.ENROLLMENTS_SUBMIT') }}
            </woot-button>
            <button class="button clear" @click.prevent="onClose">
              {{ $t('IMPORT_SCHOOL_CONTACT.FORM.CANCEL') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import Modal from '../../../../components/Modal';
import { mapGetters } from 'vuex';
import alertMixin from 'shared/mixins/alertMixin';
import { CONTACTS_EVENTS } from '../../../../helper/AnalyticsHelper/events';

export default {
  components: {
    Modal,
  },
  mixins: [alertMixin],
  props: {
    onClose: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      show: true,
      file: '',
    };
  },
  computed: {
    ...mapGetters({
      uiFlags: 'contacts/getUIFlags',
    }),
  },
  mounted() {
    this.$track(CONTACTS_EVENTS.IMPORT_MODAL_OPEN);
  },
  methods: {
    async uploadFileWithContacts() {
      try {
        if (!this.file) return;
        await this.$store.dispatch('contacts/import', {file: this.file, dataType: 'contacts'});
        this.onClose();
        this.showAlert(this.$t('IMPORT_CONTACTS.SUCCESS_MESSAGE'));
        this.$track(CONTACTS_EVENTS.IMPORT_SUCCESS);
      } catch (error) {
        this.showAlert(
          error.message || this.$t('IMPORT_CONTACTS.ERROR_MESSAGE')
        );
        this.$track(CONTACTS_EVENTS.IMPORT_FAILURE);
      }
    },
    async uploadFileWithEnrollments() {
      try {
        if (!this.file) return;
        await this.$store.dispatch('contacts/import', {file: this.file, dataType: 'enrollments'});
        this.onClose();
        this.showAlert(this.$t('IMPORT_CONTACTS.SUCCESS_MESSAGE'));
        this.$track(CONTACTS_EVENTS.IMPORT_SUCCESS);
      } catch (error) {
        this.showAlert(
          error.message || this.$t('IMPORT_CONTACTS.ERROR_MESSAGE')
        );
        this.$track(CONTACTS_EVENTS.IMPORT_FAILURE);
      }
    },
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
    },
  },
};
</script>
